import { UIIcon } from '../../config/icons';
import { FI18NPageImage } from '../mdl/f-page-block';
import { uiSetBG } from '../ui/bg';
import { $el } from '../ui/elements';
import { UIClassesSpec } from '../ui/types';
import { the_language } from '../y/i18n';
import { yLoadAsyncScript } from '../y/util';

export function makeImage(i: FI18NPageImage, aspect?: boolean, classes?: UIClassesSpec, scale: number = 1) {
    const image = $el.DIV(['tl-image', classes, aspect && 'm-aspect']);
    const v = i.all || i[the_language] || i.en!;
    uiSetBG(image, { media: v.image, size: '100% 100%' });
    image.style.setProperty('--ui-width', `${v.width * scale}px`);
    if(aspect)
        image.style.setProperty('--ui-aspect', `${v.aspect}`);
    else
        image.style.setProperty('--ui-height', `${v.height}px`);
    return image;
}

export function makeCoverImage(i: FI18NPageImage, classes?: UIClassesSpec) {
    const image = $el.DIV(classes);
    const v = i.all || i[the_language] || i.en!;
    uiSetBG(image, { media: v.image });
    return image;
}

export function makeStar(half: boolean = false) {
    if(half) {
        return $el.DIV('r-star', [$el.ICON(UIIcon.STAR | UIIcon.WEIGHT_SOLID, 'r-half'), $el.ICON(UIIcon.STAR_HALF | UIIcon.WEIGHT_SOLID)])
    } else {
        return $el.DIV('r-star', $el.ICON(UIIcon.STAR | UIIcon.WEIGHT_SOLID))
    }
}

let hubspot_promise: Promise<void> | undefined;

export function loadHubspot() {
    return hubspot_promise ??= yLoadAsyncScript('https://js.hsforms.net/forms/shell.js');
}